<div [ngClass]="{'field--error': errorMessages.length}">
    <div class="field__label">Social Security Number</div>
    <div class="field field--inline">
        <ObfuscatedTextField
            fieldId="ssn-area"
            (onValueChange)="onAreaChange($event)"
            maxlength="3"
            (onFocus)="clearValidationErrors()"
        ></ObfuscatedTextField>
        <div class="character">-</div>
        <ObfuscatedTextField
            fieldId="ssn-group"
            (onValueChange)="onGroupChange($event)"
            maxlength="2"
            (onFocus)="clearValidationErrors()"
        ></ObfuscatedTextField>
        <div class="character">-</div>
        <ObfuscatedTextField
            fieldId="ssn-serial"
            (onValueChange)="onSerialChange($event)"
            maxlength="4"
            (onBlur)="validate()"
            (onFocus)="clearValidationErrors()"
        ></ObfuscatedTextField>
    </div>
    <ErrorMessages [errorMessages]="getErrorMessages()"></ErrorMessages>
</div>
